import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0277c593"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, "Do you want the sentences read out loud?", -1))
const _hoisted_2 = { class: "btn-icon result-ok" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-label" }, " Yes ", -1))
const _hoisted_4 = { class: "btn-icon result-wrong" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-label" }, " No ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckSvg = _resolveComponent("CheckSvg")!
  const _component_XSvg = _resolveComponent("XSvg")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "sf-btn select-btn",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('select', true)), ["prevent"]))
      }, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_CheckSvg)
        ]),
        _hoisted_3
      ]),
      _createElementVNode("button", {
        class: "sf-btn select-btn",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('select', false)), ["prevent"]))
      }, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_XSvg)
        ]),
        _hoisted_5
      ])
    ])
  ]))
}